module.exports = __webpack_public_path__ + "img/91316.prt.e1766635.jpg";